module.exports = __webpack_public_path__ + "src/img/close.d57b6e60.svg";